import { SKILL_LABELS, type Skill } from '@ready/shared';

/** Percent per skill as bars (native <progress>, CSP-safe). Lowest first. */
export function SkillBars({ skills }: { skills: Partial<Record<Skill, number>> }) {
  const rows = (Object.entries(skills) as Array<[Skill, number]>).sort((a, b) => a[1] - b[1]);
  return (
    <ul className="space-y-3">
      {rows.map(([skill, pct]) => {
        const tone = pct >= 70 ? 'good' : pct >= 40 ? 'mid' : 'low';
        return (
          <li key={skill}>
            <div className="flex justify-between text-sm">
              <span>{SKILL_LABELS[skill]}</span>
              <span className="tabular-nums text-muted-foreground">{pct}%</span>
            </div>
            <progress
              max={100}
              value={pct}
              aria-label={`${SKILL_LABELS[skill]}: ${pct}%`}
              className={`mt-1 h-2 w-full appearance-none overflow-hidden rounded-full [&::-webkit-progress-bar]:bg-muted [&::-webkit-progress-value]:rounded-full [&::-moz-progress-bar]:rounded-full ${
                tone === 'good'
                  ? '[&::-webkit-progress-value]:bg-india-green [&::-moz-progress-bar]:bg-india-green'
                  : tone === 'mid'
                    ? '[&::-webkit-progress-value]:bg-saffron [&::-moz-progress-bar]:bg-saffron'
                    : '[&::-webkit-progress-value]:bg-destructive [&::-moz-progress-bar]:bg-destructive'
              }`}
            />
          </li>
        );
      })}
    </ul>
  );
}
